import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { ResponseModel,GenericApiResponseModel } from "@model/api.model";
import { TokenService } from '@services/rest/token.service';
import { CustomerRequestModel } from "@model/customer.model";


@Injectable({
    providedIn: "root",
})
export class CustomerApiService {

    constructor(
        private http: HttpClient,
        ) {
    }

    getCustomerList(model: CustomerRequestModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/customer/list', model
        );
    }

}
